import { getSummary } from '../../apiCalls'
import { Id } from '../../model/model'
import { AppThunkPromise, TeloDispatch } from '../../store'
import { slice } from './slice'

const fetchSummary =
	(patientId: Id): AppThunkPromise =>
	(dispatch: TeloDispatch) =>
		getSummary(patientId).then(s => {
			s && dispatch(slice.actions._setSummary(s))
		})

const summaryActions = {
	...slice.actions,
	fetchSummary,
}

export default summaryActions
